import {Notification, ServiceApi} from '@payroll/optimus-common';
import BaseComponent from '@/components/base/BaseComponent';
import {Component} from 'vue-property-decorator';

@Component({})
export default class UsersPhoneUpdateComponent extends BaseComponent {

    private updateMode: boolean = false;
    public files: File[] = [];

    public onUploadFile(): any {
        this.updateMode = true;
        if (this.files.length > 0) {
            let formData: FormData = new FormData()
            this.files.forEach((uploadedFile: any) => {
                formData.append('file', uploadedFile.file)
            });
            new ServiceApi()
                .setToken(this.accessToken)
                .setRequestName('updateMemberPhonesFile')
                .setFormData(formData)
                .post(this)
        }
        /* In case no file is chosen */
        else {
            const notificationObj: Notification = {
                toShow: true,
                message: 'no_file_chosen',
                icon: 'warning',
                secondsToDisappear: 3
            }
            this.$root.$emit('showAlertNotification', notificationObj)
        }
    }

    public onSuccess(data: any, requestName?: string, message?: string): void {
        this.files = [];
        const notificationObj: Notification = {
            toShow: true,
            message: data.successCount ? (data.successCount + ' ' + this.$t('file_uploaded_successfully')) : this.$t('no_data_update') + (data.failureCount ? '. ' + this.$t('file_uploaded_failure') : ''),
            icon: data.successCount ? 'checkCircle' : 'warning',
            secondsToDisappear: 3
        }
        this.$root.$emit('showAlertNotification', notificationObj)
    }

    onError(messages: string[], code: number, requestName?: string): void {
        const notificationObj: Notification = {
            toShow: true,
            message: messages && messages.length > 0 ? messages[0] : 'general_error_msg',
            icon: 'warning',
            secondsToDisappear: 3
        }
        this.$root.$emit('showAlertNotification', notificationObj)
    }
}

